import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Clickable } from 'src/components/clickable';
import { animations, layout, styledUtils } from 'src/components/base';
import { PriceLabel } from 'src/components/offer/price/price-label';
import { ProductImage } from 'src/components/product-image';
import {
  ProductCheckbox,
  productCheckboxHoverStyle,
} from 'src/components/product-checkbox';
import { Tooltip as TooltipComponent } from 'src/components/tooltip-new';

export const Tooltip = styled(TooltipComponent)``;

const indicateNewColumnAnimation = animations.highlightNewContentAnimation();

export const TdLink = styled(Clickable)`
  cursor: pointer;
  display: inline;
  padding: ${layout.measurements.spacing025} ${layout.measurements.spacing050};
  text-align: left;
`;

type RawTdProps = { indicateNewColumn?: boolean };
export const RawTd = styled.td<RawTdProps>`
  font-size: ${layout.measurements.fontSizeSmall};
  border-bottom: 1px solid ${({ theme }) => theme.lines.secondary};
  position: relative;
  & > a {
    display: block;
  }
  ${({ indicateNewColumn }) => indicateNewColumn && indicateNewColumnAnimation}
`;

type TrProps = { selected?: boolean };
export const Tr = styled.tr<TrProps>`
  cursor: pointer;
  ${props =>
    props.selected &&
    css`
      ${TdLink}::before {
        ${styledUtils.overlay(props.theme.bg.productCompareLight)}
      }
    `}

  @media (pointer: fine) {
    &:hover {
      ${/* sc-selector */ TdLink}::after {
        ${styledUtils.overlay()}
      }
    }
  }
  td:last-child a {
    padding-right: 0;
  }
`;

export const ProductNameTable = styled.h3`
  font: inherit;
  font-weight: 600;
  font-size: ${layout.measurements.fontSizeSmall};
  margin-bottom: 0;
  flex: 1;
`;

export const Price = styled(PriceLabel)`
  font-size: ${layout.measurements.fontSizeNormal};
`;

const ImageLayout = css`
  height: 32px;
  width: 32px;
  margin-right: ${layout.measurements.spacing050};
`;

export const Image = styled(ProductImage)`
  ${ImageLayout}
`;

export const ImagePlaceholder = styled.div`
  ${ImageLayout}
`;

type TdProps = {
  children: ReactNode;
  to?: string;
  'aria-label': string;
  'data-test'?: string;
  indicateNewColumn?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};
export const Td = ({ children, to, indicateNewColumn, ...rest }: TdProps) => (
  <RawTd indicateNewColumn={indicateNewColumn}>
    <TdLink to={to} {...rest}>
      {children}
    </TdLink>
  </RawTd>
);

export const NameTd = RawTd;

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NameLink = styled(TdLink)`
  && {
    box-sizing: border-box;
    display: flex;
    flex: 1 0 auto;
    max-width: 100%;
    align-items: center;
  }
`;

export const CampaignBadgeWrapper = styled.div`
  margin-left: ${layout.measurements.spacing050};
  min-width: 20px;
`;

export const PropertyTd = styled(Td)`
  max-width: 80px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const PropertyContainer = styled.div`
  max-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CompareCheckbox = styled(ProductCheckbox)`
  margin-left: ${layout.measurements.spacing050};
  ${/* sc-selector */ Tr}:hover & {
    ${productCheckboxHoverStyle}
  }
`;

export const PriceDealContainer = styled.div`
  display: flex;
`;

export const Center = styled.div`
  margin: auto;
  width: fit-content;
`;
